import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import LogRocket from 'logrocket';
import qs from 'query-string';
import {withRouter} from 'react-router-dom';
import {FormattedHTMLMessage, injectIntl} from 'react-intl';
import InputField from '../components/inputs/input_field';
import * as tracking from '../tracking';
import SetFirstTimePasswordMutation from '../mutations/set_first_time_password_mutation';
import VerifyFirstTimeKeyMutation from '../mutations/verify_first_time_key_mutation';
import CreateSalesforceVerificationKeyMutation from '../mutations/create_salesforce_verification_key_mutation';
import {timezones} from '../constants';
import MomentTimezone from 'moment-timezone';
import UploadingOverlay from '../forecast-app/shared/components/uploading-overlay/uploading_overlay';
import Util from '../forecast-app/shared/util/util';
import TrackPersonEventMutation from '../mutations/track_person_event_mutation';
import 'whatwg-fetch'; //IE 11 fetch polyfill
import DropdownV2 from '../forecast-app/shared/components/dropdowns/dropdown';
import countryPhoneCodes from '../countryPhoneCodes';
import MobileDropdownV1 from '../components/new-ui/mobile_dropdown';
import {cloneDeep} from 'lodash';
import Checkbox from '../components/new-ui/check_box';
import {Step1Icon, Step2Icon, LastStepIcon} from '../images/components/signup-step-illustration/hexagon-icon';
class firstLoginV2 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			stepIndex: 0,
			loggedIn: this.props.viewer.actualPersonId,
			showContent: false,
			isFirstPersonInCompany: false,
			isAutojoinAvailable: false,
			name: '',
			title: '',
			countryCode: '',
			countryCodeValid: true,
			phone: '',
			password: '',
			website: null,
			forecastPickOption: [],
			toolUsed: '',
			companySize: '',
			companyRoleOption: '',
			companySizeValid: true,
			companySizeOptions: ['1-9', '10-24', '25-49', '50-99', '100-199', '200-499', '500+'],
			companyRoleOptions: '',
			companyRoleValid: true,
			tourOption: null,
			loading: false,
			acceptTerms: false,
			acceptAutoJoin: true,
			showPasswordHelp: false,
			acceptTermsValid: true,
			ipGeolocation: '',
			userJoining: false,
		};

		this.getDomainFromEmail = this.getDomainFromEmail.bind(this);

		if (this.props.viewer.actualPersonId) {
			this.props.history.push('/');
		}
		this.props.setLocaleFromBrowser();
	}

	componentDidMount() {
		// Segment
		tracking.trackPage('first');

		if (this.state.loggedIn) {
			return;
		} else if (process.env.CIRCLE_BRANCH === 'production') {
			fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'ip_location_info')
				.then(result => result.json())
				.then(res => {
					const preSelectedCountryCode = countryPhoneCodes.countryPhoneCodes.filter(code => code.code === res.country_code2).map(code => code.code + ' (' + code.dial_code + ')');
					if (preSelectedCountryCode.length > 0) {
						this.handleInputChange('countryCode', preSelectedCountryCode[0]);
					}
				});
		}
		const {formatMessage} = this.props.intl;
		if (qs.parse(this.props.location.search).economic_token) {
			const headers = new Headers();
			headers.append('Content-Type', 'application/json');
			const init = {headers: headers};

			fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'economic_self?token=' + qs.parse(this.props.location.search).economic_token, init)
				.then(result => result.json())
				.then(json => {
					this.setState({
						name: json.person_name,
						website: json.company_website,
						phone: json.company_phone,
					});
				});
		}

		try {
			if (window.amplitude) {
				if (qs.parse(this.props.location.search).deviceId) {
					window.amplitude.init(process.env.CIRCLE_BRANCH === 'production' ? '3dd776b24763144b2feee32dc7954ea2' : '0353fe15cd60513484112914cf4583cf', null, {
						deviceId: qs.parse(this.props.location.search).deviceId,
					});
				}
			}
		} catch (e) {}

		const onSuccess = e => {
			const companyRoleOptions = e.verifyFirstTimeKey.roles ? cloneDeep(e.verifyFirstTimeKey.roles) : null;
			if (companyRoleOptions) {
				companyRoleOptions.push({id: 'Other', name: formatMessage({id: 'common.select-other'}) + '..'});
			}
			if (e.verifyFirstTimeKey.isKeyValid) {
				const stateData = {
					showContent: true,
					isFirstPersonInCompany: e.verifyFirstTimeKey.isFirstPersonInCompany,
					isAutojoinAvailable: e.verifyFirstTimeKey.isAutojoinAvailable,
					userJoining: e.verifyFirstTimeKey.person.joined,
					companyRoleOptions: companyRoleOptions,
				};

				try {
					if (process.env.CIRCLE_BRANCH === 'production') {
						LogRocket.init('forecast/forecast-nod93');
					}
				} catch (e) {}

				// Currently only 1 step, but keeping logic as number of steps is subject to change
				let steps = [];
				if (e.verifyFirstTimeKey.person.firstName !== '') {
					let firstName = '';

					if (e.verifyFirstTimeKey.person.firstName && e.verifyFirstTimeKey.person.firstName !== e.verifyFirstTimeKey.person.email) {
						firstName = e.verifyFirstTimeKey.person.firstName;
					}

					let lastName = e.verifyFirstTimeKey.person.lastName ? e.verifyFirstTimeKey.person.lastName : '',
						JobTitle = e.verifyFirstTimeKey.person.jobTitle ? e.verifyFirstTimeKey.person.jobTitle : '',
						phoneNumber = e.verifyFirstTimeKey.person.phone ? e.verifyFirstTimeKey.person.phone : '',
						companySize = e.verifyFirstTimeKey.person.company.companySize ? e.verifyFirstTimeKey.person.company.companySize : '';

					stateData.name = firstName + ' ' + lastName;
					stateData.title = JobTitle;
					stateData.phone = phoneNumber;
					stateData.companySize = companySize;
					steps = [
						{
							validate: this.validateStepOne.bind(this),
						},
					];
				}
				if (e.verifyFirstTimeKey.isFirstPersonInCompany) {
					steps = [
						{
							validate: this.validateStepOne.bind(this),
						},
					];
				}
				if (qs.parse(this.props.location.search).economic_token) {
					steps.push({
						class: 'step-economic',
						getContent: this.getStepEconomicContent.bind(this),
						whiteLogo: true,
						validate: () => {
							return true;
						},
					});
				}

				if (qs.parse(this.props.location.search).salesforce) {
					steps.push({
						class: 'step-salesforce',
						getContent: this.getStepSalesforceContent.bind(this),
						whiteLogo: true,
						validate: () => {
							return true;
						},
					});
				}
				this.steps = steps;
				this.setState(stateData);
			} else {
				this.props.history.push('/login');
			}
		};
		Util.CommitMutation(
			VerifyFirstTimeKeyMutation,
			{
				key: this.props.match.params.key,
			},
			onSuccess
		);
	}

	onPasswordFocus() {
		this.setState({showPasswordHelp: true});
	}

	onPasswordBlur() {
		const newState = {};

		if (Util.validatePassword(this.state.password).valid || this.props.viewer.scimProvisioned) {
			newState.showPasswordHelp = false;
		} else {
			newState.showPasswordHelp = true;
		}
		this.setState(newState);
	}

	handleInputChange(field, value) {
		this.setState({[field]: value, [field + 'Valid']: true});
	}

	handleDropdownChange(field, value) {
		this.setState({[field]: value.value, [field + 'Valid']: true});
	}

	handleAcceptTermsChange() {
		this.setState({acceptTerms: !this.state.acceptTerms, acceptTermsValid: true});
	}

	handleAcceptAutoJoin() {
		this.setState({acceptAutoJoin: !this.state.acceptAutoJoin});
	}

	handleContinueClick() {
		const currentStep = this.steps[this.state.stepIndex];
		if (!currentStep.validate()) {
			return;
		}

		let eventName = null;
		if (this.state.stepIndex === this.steps.length - 1) {
			if (this.steps.length === 3) {
				if (qs.parse(this.props.location.search).economic_token) {
					eventName = 'signup_completed_page_economic';
				} else if (qs.parse(this.props.location.search).salesforce) {
					eventName = 'signup_completed_page_salesforce';
				}
			} else {
				eventName = 'signup_completed_page_' + this.steps.length;
			}
			Util.CommitMutation(TrackPersonEventMutation, {
				name: eventName,
				signupKey: this.props.match.params.key,
			});
			tracking.trackEvent(eventName);
			// last step
			this.handleSubmit();
		} else {
			if (this.state.stepIndex === 0 && !this.state.isFirstPersonInCompany) {
				eventName = 'signup_completed_page_1';
				Util.CommitMutation(TrackPersonEventMutation, {
					name: eventName,
					signupKey: this.props.match.params.key,
				});
				tracking.trackEvent(eventName);
				this.handleSubmit(); //Skip step two and three if the person is not the first person in the company
			} else {
				if (this.state.stepIndex === 0) {
					eventName = 'signup_completed_page_1';
				} else if (this.state.stepIndex === 1) {
					eventName = 'signup_completed_page_2';
				} else if (this.state.stepIndex === 2) {
					eventName = 'signup_completed_page_3';
				}
				Util.CommitMutation(TrackPersonEventMutation, {
					name: eventName,
					signupKey: this.props.match.params.key,
				});
				tracking.trackEvent(eventName);
				this.setState({stepIndex: this.state.stepIndex + 1});
			}
		}
	}

	handleSubmit() {
		this.setState({loading: true});
		const fullName = this.state.name.trim();
		let firstName;
		let lastName;
		if (fullName.indexOf(' ') <= 0) {
			firstName = fullName;
			lastName = '';
		} else {
			firstName = fullName.substr(0, fullName.indexOf(' ')).trim();
			lastName = fullName.substr(fullName.indexOf(' ') + 1).trim();
		}
		const email = this.props.viewer.email.trim(),
			password = this.state.password.trim(),
			phone = this.state.phone,
			countryPhoneCode = this.state.countryCode; //.replace(/[A-Za-z]/, '');

		const onSuccess = response => {
			if (response.setFirstTimePassword.success) {
				this.setState({loading: false});
				Util.localStorageSetItem('displayMode-projects-overview', 'cards');
				if (qs.parse(this.props.location.search).salesforce) {
					const onSalesforceSuccess = ({createSalesforceVerificationKey}) => {
						this.setState({loading: false});
						const redirectUri = process.env.SALESFORCE_REDIRECT_URI;
						const clientId = process.env.SALESFORCE_CLIENT_ID;
						window.location.href = `https://login.salesforce.com/services/oauth2/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&state=${createSalesforceVerificationKey.key}`;
					};
					Util.CommitMutation(CreateSalesforceVerificationKeyMutation, null, onSalesforceSuccess);
					return;
				}
				tracking.trackEvent('Signup Flow Completed');
				this.props.history.push('/projects');
			}
		};

		let timezone = timezones.filter(timezone => {
			return timezone.value === MomentTimezone.tz.guess();
		});
		timezone = timezone.length ? timezone[0].value : undefined;

		const language = navigator.language || navigator.userLanguage;
		const noDanishDefaultLanguage = language.startsWith('da') ? 'en-EU' : language;

		Util.CommitMutation(
			SetFirstTimePasswordMutation,
			{
				email: email,
				title: this.state.companyRoleOption && this.state.companyRoleOption !== 'Other' && !this.state.isFirstPersonInCompany ? this.state.companyRoleOption.label : this.state.title,
				password: password,
				firstName: firstName,
				lastName: lastName,
				phoneNumber: countryPhoneCode + phone,
				website: this.getDomainFromEmail(),
				timezone: timezone,
				key: this.props.match.params.key,
				language: noDanishDefaultLanguage,
				interest: this.state.forecastPickOption.join(),
				toolUsed: this.state.toolUsed,
				companySize: this.state.companySize,
				roleId: this.state.companyRoleOption && this.state.companyRoleOption !== 'Other' ? this.state.companyRoleOption : null,
				economicToken: qs.parse(this.props.location.search).economic_token,
				termsVersionAccepted: 'April2018',
				autoJoinAccepted: this.state.isAutojoinAvailable ? this.state.acceptAutoJoin : false,
			},
			onSuccess
		);
	}

	getDomainFromEmail() {
		return this.props.viewer.email != null ? this.props.viewer.email.split('@')[1] : '';
	}

	validateStepOne() {
		const fullName = this.state.name.trim();
		let firstName;
		if (fullName.indexOf(' ') <= 0) {
			firstName = fullName;
		} else {
			firstName = fullName.substr(0, fullName.indexOf(' ')).trim();
		}
		let phoneNumber = this.state.isFirstPersonInCompany ? this.state.phone.length > 0 : true;
		const email = this.props.viewer.email ? this.props.viewer.email.trim() : '';

		const titleValid = this.state.isFirstPersonInCompany || this.state.companyRoleOption === 'Other' ? this.state.title.length > 0 : true;
		const countryCodeValid = this.state.isFirstPersonInCompany ? this.state.countryCode.length > 0 : true;
		const companySizeValid = this.state.isFirstPersonInCompany ? this.state.companySize.length > 0 : true;
		const companyRoleValid = this.state.isFirstPersonInCompany || !this.state.userJoining || this.state.companyRoleOption;
		this.setState({
			nameValid: firstName.length > 0,
			phoneValid: phoneNumber,
			titleValid: titleValid,
			countryCodeValid: countryCodeValid,
			companySizeValid: companySizeValid,
			showPasswordHelp: !Util.validatePassword(this.state.password).valid,
			acceptTermsValid: this.state.acceptTerms,
			passwordValid: /*this.props.viewer.scimProvisioned || */ Util.validatePassword(this.state.password).valid,
			websiteValid: true,
			companyRoleValid: companyRoleValid,
		});
		return (email.length && this.props.viewer.scimProvisioned) || (Util.validatePassword(this.state.password).valid && firstName.length && titleValid && phoneNumber && this.state.acceptTerms && companySizeValid && companyRoleValid);
	}

	getStepEconomicContent() {
		const {formatMessage} = this.props.intl;
		return (
			<div className="step-economic-content">
				<h2 className="title">{formatMessage({id: 'signup.economic-connected'})}</h2>
				<div className="text">{formatMessage({id: 'settings.app_catalog.economic.description'}).split('<br/>')[0]}</div>
				<div className="text">{formatMessage({id: 'settings.app_catalog.economic.description'}).split('<br/>')[1]}</div>
			</div>
		);
	}

	getStepSalesforceContent() {
		const {formatMessage} = this.props.intl;
		return (
			<div className="step-salesforce-content">
				<h2 className="title">{formatMessage({id: 'signup.salesforce_confirmation_header'})}</h2>
				<div className="text">{formatMessage({id: 'signup.salesforce_confirmation_text'})}</div>
			</div>
		);
	}

	getCompanyRoleOptions() {
		const roleOptions = this.state.companyRoleOptions.map((option, index) => ({label: option.name, value: option.id, cy: 'role' + index}));
		return roleOptions;
	}

	render() {
		//Do not display anything if user will be redirected or is still waiting for key verification
		if (this.state.loggedIn || !this.state.showContent) return null;
		const {formatMessage} = this.props.intl;
		const companySizeOptions = this.state.companySizeOptions.reverse().map((option, index) => ({label: option, value: option, cy: 'size' + index}));
		const countryCodeOptions = countryPhoneCodes.countryPhoneCodes
			.map((code, index) => ({
				label: code.code + ' (' + code.dial_code + ')',
				value: code.code + ' (' + code.dial_code + ')',
				cy: 'code' + index,
			}))
			.sort((a, b) => {
				if (a.label < b.label) {
					return -1;
				}
				if (a.label > b.label) {
					return 1;
				}
				return 0;
			});

		const companyRoleOptions = this.state.companyRoleOptions.map((option, index) => ({label: option.name, value: option.id, cy: 'role' + index}));

		return (
			<div className="first-login-v2-outer-wrapper">
				{this.state.loading ? <UploadingOverlay useGrayOverlay={true} /> : null}
				<div className="inner-wrapper">
					<div className="signup-container">
						<div className="signup-title">{formatMessage({id: 'first_login.title'})}</div>
						<div className="signup-form-container">
							<InputField
								autoFocus={true}
								value={this.state.name}
								maxLength={300}
								onChange={this.handleInputChange.bind(this, 'name')}
								placeholder={formatMessage({id: 'login.name'}) + ' *'}
								type="text"
								id="name"
								cy="name"
								hideLabel={true}
								inputValid={this.state.nameValid}
							/>

							{this.state.userJoining ? (
								<div className="role-info-wrapper">
									<div>
										<MobileDropdownV1
											value={this.state.companyRoleOption}
											label={formatMessage({id: 'login.select_role'}) + ' *'}
											options={companyRoleOptions}
											handleChange={this.handleInputChange.bind(this, 'companyRoleOption')}
											cy="company-role-mobile-dropdown"
											placeholder={formatMessage({id: 'login.select_role_placeholder'})}
											invalidInput={!this.state.companyRoleValid}
										/>
										<DropdownV2
											value={this.state.companyRoleOption}
											hideLabel={true}
											onChange={this.handleDropdownChange.bind(this, 'companyRoleOption')}
											options={companyRoleOptions}
											placeholder={formatMessage({id: 'login.select_role_placeholder'}) + ' *'}
											invalidInput={!this.state.companyRoleValid}
											inputCy={'company-role-dropdown'}
											stayOpenOnSelect={false}
										/>
									</div>
								</div>
							) : null}

							{this.state.isFirstPersonInCompany || this.state.companyRoleOption === 'Other' ? (
								<InputField
									value={this.state.title}
									maxLength={300}
									onChange={this.handleInputChange.bind(this, 'title')}
									placeholder={formatMessage({id: 'first_login.enter_job_title'}) + ' *'}
									type="text"
									id="title"
									cy="title"
									hideLabel={true}
									inputValid={this.state.titleValid}
								/>
							) : null}

							{!this.state.isFirstPersonInCompany && !this.state.userJoining ? (
								<InputField
									value={this.state.title}
									maxLength={300}
									onChange={this.handleInputChange.bind(this, 'title')}
									placeholder={formatMessage({id: 'first_login.enter_job_title'}) + ' *'}
									type="text"
									cy="invited-user-title"
									hideLabel={true}
									inputValid={this.state.titleValid}
								/>
							) : null}

							{this.state.isFirstPersonInCompany ? (
								<div className="first-person-info">
									<div className="phone-info-wrapper">
										<MobileDropdownV1
											value={this.state.countryCode}
											options={countryCodeOptions}
											handleChange={this.handleInputChange.bind(this, 'countryCode')}
											cy="country-code-mobile-dropdown"
											placeholder={this.state.countryCode !== '' ? this.state.countryCode.value : '+-- *'}
											invalidInput={!this.state.countryCodeValid}
										/>

										<DropdownV2
											value={this.state.countryCode}
											onChange={this.handleDropdownChange.bind(this, 'countryCode')}
											options={countryCodeOptions}
											hideLabel={true}
											inputCy={'country-code-dropdown'}
											invalidInput={!this.state.countryCodeValid}
											placeholder={this.state.countryCode !== '' ? this.state.countryCode.value : '+-- *'}
											stayOpenOnSelect={false}
										/>

										<InputField
											value={this.state.phone}
											maxLength={191}
											onChange={this.handleInputChange.bind(this, 'phone')}
											placeholder={formatMessage({id: 'login.enter-phone'}) + ' *'}
											id="phone"
											cy="phone"
											className="phone-number"
											hideLabel={true}
											inputValid={this.state.phoneValid}
										/>
									</div>

									<div className="size-wrapper">
										<div>
											<MobileDropdownV1
												value={this.state.companySize}
												options={companySizeOptions}
												cy="company-size-mobile-dropdown"
												placeholder={formatMessage({id: 'login.choose-size'}) + ' *'}
												handleChange={this.handleInputChange.bind(this, 'companySize')}
												invalidInput={!this.state.companySizeValid}
											/>

											<DropdownV2
												value={this.state.companySize}
												onChange={this.handleDropdownChange.bind(this, 'companySize')}
												options={companySizeOptions}
												hideLabel={true}
												placeholder={formatMessage({id: 'login.choose-size'}) + ' *'}
												invalidInput={!this.state.companySizeValid}
												inputCy={'company-size-dropdown'}
												stayOpenOnSelect={false}
											/>
										</div>
									</div>
								</div>
							) : null}

							{this.props.viewer.scimProvisioned ? null : (
								<div>
									{/*This is only here to make sure that the company size dropdown is not autofilled with browser extensions*/}
									<input tabIndex={'-1'} className="fake-input" type="text" style={{height: 0, outline: 'none', border: 0, padding: 0}} />

									<InputField
										value={this.state.password}
										onChange={this.handleInputChange.bind(this, 'password')}
										onFocus={this.onPasswordFocus.bind(this)}
										onBlur={this.onPasswordBlur.bind(this)}
										placeholder={formatMessage({id: 'login.enter-password'}) + ' *'}
										type="password"
										id="password"
										name="password"
										cy="password"
										hideLabel={true}
										inputValid={this.state.passwordValid}
									/>
									{this.state.showPasswordHelp && !Util.validatePassword(this.state.password).valid ? <div className="password-helper-text">{Util.getPasswordHelpText(this.state.password)}</div> : null}
								</div>
							)}

							{this.state.isFirstPersonInCompany && this.state.isAutojoinAvailable ? (
								<div className="allow-autojoin">
									<Checkbox cy={'accept-autojoin-checkbox'} isChecked={this.state.acceptAutoJoin} onChange={this.handleAcceptAutoJoin.bind(this)}></Checkbox>
									<label className="terms-checkbox-label" htmlFor="accept-auto-join">
										<FormattedHTMLMessage id="login.auto-join" values={{key: '@' + this.getDomainFromEmail()}} />
									</label>
								</div>
							) : null}

							<div className={'terms-outer' + (this.state.acceptTermsValid ? '' : ' warning')}>
								<Checkbox cy={'accept-terms-checkbox'} checked={this.state.acceptTerms} onChange={this.handleAcceptTermsChange.bind(this)}></Checkbox>
								<label className="terms-checkbox-label" htmlFor="accept-terms-checkbox">
									{formatMessage({id: 'onboarding.login_flow.terms_admin_0'})}
									<a target="_blank" rel="noopener noreferrer" href="https://www.forecast.app/terms-and-conditions">
										{formatMessage({id: 'onboarding.login_flow.terms_admin_1'})}
									</a>{' '}
									{formatMessage({id: 'onboarding.login_flow.terms_admin_2'})}
								</label>
							</div>

							<button data-cy="done-btn" onClick={this.handleContinueClick.bind(this)} className="signup-submit-btn">
								START WORKING
							</button>
						</div>
						<div className="current-step-illustration">
							<div className="step-hexagon-wrapper">
								<Step1Icon />
							</div>
							<div className="step-line first-line" />
							<div className="step-hexagon-wrapper">
								<Step2Icon />
							</div>
							<div className="step-line" />
							<div className="step-hexagon-wrapper">
								<LastStepIcon />
							</div>
						</div>
					</div>
					<div className="logo" />
				</div>
			</div>
		);
	}
}

const firstLoginV2Query = graphql`
	query firstLoginV2_Query {
		viewer {
			component(name: "first_login")
			...firstLoginV2_viewer
		}
	}
`;

export {firstLoginV2Query};

export default createFragmentContainer(injectIntl(withRouter(firstLoginV2)), {
	viewer: graphql`
		fragment firstLoginV2_viewer on Viewer {
			id
			actualPersonId
			email
			scimProvisioned
		}
	`,
});
